import { BaseError } from './base';
import { BaseErrorCodes } from './codes';

export class CoreError extends BaseError {
  constructor(message: string, detailCode?: string, details?: unknown) {
    super(message, BaseErrorCodes.Core, detailCode, details);
  }
}

export class ValidationError extends BaseError {
  constructor(message: string, detailCode?: string, details?: unknown) {
    super(message, BaseErrorCodes.Validation, detailCode, details);
  }
}

export class NotFoundError extends BaseError {
  constructor(message: string, detailCode?: string, details?: unknown) {
    super(message, BaseErrorCodes.NotFound, detailCode, details);
  }
}

// Task engine domain error (client-side queue/engine)
export class TaskEngineError extends BaseError {
  constructor(message: string, detailCode?: string, details?: unknown) {
    super(message, BaseErrorCodes.Core, detailCode, details);
  }
}
